function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M149.333,64C90.517,64,42.667,111.829,42.667,170.667c0,5.888,4.779,10.667,10.667,10.667S64,176.555,64,170.667    c0-47.061,38.272-85.333,85.333-85.333c5.888,0,10.667-4.779,10.667-10.667S155.221,64,149.333,64z",
  "data-original": "#000000",
  className: "active-path",
  "data-old_color": "#000000",
  fill: "#FE3434"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M362.667,21.334c-40.405,0-78.635,16.213-106.667,44.864c-28.032-28.651-66.261-44.864-106.667-44.864    C66.987,21.334,0,88.321,0,170.667c0,37.163,14.997,73.536,43.349,105.173c48.789,54.4,203.541,210.112,205.099,211.669    c1.984,2.027,4.715,3.157,7.552,3.157c2.837,0,5.568-1.131,7.573-3.115c1.557-1.557,156.309-157.269,205.099-211.691    C497.003,244.224,512,207.872,512,170.667C512,88.341,445.013,21.334,362.667,21.334z M452.779,261.589    C410.56,308.693,287.765,432.832,256,464.853c-31.787-32.021-154.56-156.16-196.779-203.243    c-17.28-19.328-37.888-50.731-37.888-90.944c0-70.613,57.408-128,128-128c38.144,0,74.027,16.853,98.453,46.251    c4.053,4.885,12.373,4.885,16.405,0c24.448-29.419,60.331-46.251,98.475-46.251c70.592,0,128,57.408,128,128    C490.667,210.88,470.059,242.284,452.779,261.589z",
  "data-original": "#000000",
  className: "active-path",
  "data-old_color": "#000000",
  fill: "#FE3434"
}))));

var SvgAdded = function SvgAdded(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdded, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/added.8799eba8.svg";
export { ForwardRef as ReactComponent };